import * as types from './constants';

// Create Group
export const createGroupRequest = data => (
  { type: types.CREATE_GROUP_REQUEST, payload: data }
);

export const createGroupDone = data => (
  { type: types.CREATE_GROUP_DONE, payload: data }
);

export const createGroupFailed = errors => (
  { type: types.CREATE_GROUP_FAILED, payload: errors }
);

export const createGroupReset = () => (
  { type: types.CREATE_GROUP_RESET }
);